import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const PATH = publicRuntimeConfig.basePath??'';
//const PATHHH = PATH + '/';
const PATHHH = '/';

export const HOME = PATHHH + '';
export const SIGNIN = PATHHH + 'signin';
export const SIGNOUT = PATHHH + 'signout';
export const FORGOT_PASSWORD = PATHHH + 'forgot-password';
export const CHECKIN = PATHHH + 'check-in';
export const PERSONAL_INFO = PATHHH + 'check-in/personal-info';
export const SECURITY_ACCESS = PATHHH + 'check-in/security-access/';
export const DIRECT_DEBIT = PATHHH + 'check-in/direct-debit';
export const CUSTOMER_LICENCE = PATHHH + 'check-in/customer-licence';
export const INVENTORY = PATHHH + 'check-in/inventory';
export const FLEXIOFFICE = PATHHH + 'check-in/flexi-office';
export const FLEXIOFFICE_DOCS = PATHHH + 'check-in/flexi-office/documents';
export const FLEXIOFFICE_INVENTORY = PATHHH + 'check-in/flexi-office/inventory';
export const GIVE_NOTICE = PATHHH + 'give-notice';
export const SUPPORT = PATHHH + 'support';

export const MOVE_IN_DATE_CHANGE = PATHHH + 'change-move-in-date/{reservation_id}';
export const WEBSITE = 'https://www.bigyellow.co.uk';
export const TERMS_AND_CONDITIONS = WEBSITE+"/terms-and-conditions/";
export const SITE_MAINTENANCE = PATHHH +'site-maintenance'

export const DOCUMENTS_INDEX = PATHHH + "check-in/security-access/documents/";
export const DOCUMENTS_CP = PATHHH + "check-in/security-access/documents/cp";
export const DOCUMENTS_ID = PATHHH + "check-in/security-access/documents/id";
export const DOCUMENTS_PA = PATHHH + "check-in/security-access/documents/pa";
export const STORE_PAGE = PATHHH + "store/{store_name}";
export const CHANGE_EMAIL_ADDRESS = PATHHH + "settings/account-email-address";
export const CHANGE_PASSWORD = PATHHH + "settings/account-password";
export const CHANGE_PHONE_NUMBER = PATHHH + "settings/account-mobile-number";
export const CHANGE_2FA_METHOD = PATHHH + "settings/2fa-authentication-method";
export const CHANGE_AUTHENTICATOR = PATHHH + "settings/authenticator-app";
export const SETTINGS = PATHHH + "settings";

export const PATHNAME = PATH + (PATH !== '/' ? '/' : '');

export const get_website_url = (boxshop=true) => {
    const urls = {
        development: 'https://dev.bigyellow.co.uk/boxshop/',
        preprod: 'https://preprod.bigyellow.co.uk/boxshop/',
        live: 'https://www.bigyellow.co.uk/boxshop/'
    }

    let current_url = urls[process.env.NODE_ENV??'development'];

    if (boxshop === false && typeof current_url !== 'undefined') {
        current_url = current_url.replace('/boxshop', '');
    }

    return current_url??urls['live']
}

export default PATH;
